import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'privacy',
    templateUrl: './privacy.html',
    styleUrls: ['./privacy.css'],
    encapsulation: ViewEncapsulation.None
})
export class PrivacyComponent {}


// WEBPACK FOOTER //
// ./web/static/components/privacy/privacy.ts